var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierEditor.tsx";
import { forward } from 'effector';
import * as api from '@gmini/sm-api-sdk'; //TODO проверить, если не нужно удалить
// dependenciesCheckedModel.checked$.updates.watch(checkedMap => {
//   if (Object.keys(checkedMap).length > 0) {
//     userClassifierCheckedModel.reset()
//     userClassifierCheckedModel.resetMultiChecked()
//   }
// })
// userClassifierCheckedModel.checked$.updates.watch(checkedMap => {
//   if (Object.keys(checkedMap).length > 0) {
//     dependenciesCheckedModel.reset()
//     dependenciesCheckedModel.resetMultiChecked()
//   }
// })

forward({
  ɔ: {
    // Обновляем total группы классификатора
    // FSK-619 - Стрелка не пропадает при удалении разложенной модели из зависимости
    from: api.UserClassifier.removeDependency.doneData,
    to: api.UserClassifier.getMostRecent.defaultContext.submit
  },
  config: {
    sid: "ud16qr"
  }
}); //TODO проверить, если не нужно удалить
// sample({
//   clock: api.UserClassifier.removeDependency.done,
//   source: dependenciesCheckedModel.checkedList$,
//   fn(checkedList, { params: { sourceClassifierId } }) {
//     userClassifierCheckedModel.reset()
//     userClassifierCheckedModel.resetMultiChecked()
//     if (
//       checkedList.some(node => node.parentClassifierId === sourceClassifierId)
//     ) {
//       dependenciesCheckedModel.reset()
//       dependenciesCheckedModel.resetMultiChecked()
//     }
//   },
// })